import {getCustomersConfigurationList} from "../api/designHistoryApi";
import {designHistoryAction} from "../../../redux/store";
import {useDispatch, useSelector} from "react-redux";
import {useState} from "react";
import Monthly from "../component/molecules/Monthly";
import DesignHistoryLoadingMessage from "../../intro/DesignHistoryLoadingMessage";

const useHistory = () => {
  const dispatch = useDispatch();
  const currentVehicle = useSelector(state => state.optionWindow.currentVehicle);
  // const [selectedProductTab, setSelectedProductTab] = useState();


  const getConfigurationList = (customerId) => {
    getCustomersConfigurationList(customerId).then(res => {
      const { result, message, data } = res.data;

      if (result && message === "SUCCESS") {
        dispatch(designHistoryAction.setDesignHistoryList(data));
      }
    });
  }


  const truncateText = (text, maxLength) => {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
  };


  const groupByProductId = (data) => {
    if (!data) {
      return {};
    }

    const groups = {};

    data.forEach(item => {
      const {productId} = item;
      if (!groups[productId]) {
        groups[productId] = [];
      }
      groups[productId].push(item);
    });
    return groups;
  }



  const groupByYearMonth = (data) => {
    const groups = {};

    data.forEach(item => {
      const yearMonth = item.createdAt.substring(0, 7);

      if (!groups[yearMonth]) {
        groups[yearMonth] = [];
      }
      groups[yearMonth].push(item);
    });

    return groups;
  }

  const formatDateTime = (dateTimeStr) => {
    return dateTimeStr.replace('T', ' ').substring(0, 19);
  };



  const renderGroupedData = (data, componentMount, closeModal, subModalMount, closeSubModal ) => {
    const userRole = sessionStorage.getItem('userRole');


    if (!data && userRole === "CONFIGURATION_USER") {
      return (
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}>
          <DesignHistoryLoadingMessage color={"#000"}/>
        </div>
      )
    }


    const productId = currentVehicle?.id;
    const groupedProduct = groupByProductId(data);
    const groupedData = groupByYearMonth(groupedProduct[productId] || []);

    const entries = Object.entries(groupedData);

    if (entries.length === 0) {
      return (
        <div style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}>
          <p>No saved designs.</p>
          <p>Create and save your own designs to your history.</p>
        </div>
      );
    }


    return Object.entries(groupedData).map(([yearMonth, items]) => {

      const [year, month] = yearMonth.split('-');
      const monthNames = ["Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];
      const formattedDate = `${monthNames[parseInt(month) - 1]} ${year}`;

      const modalProps = { componentMount, closeModal, subModalMount, closeSubModal };
      const props = { yearMonth, items, formattedDate, truncateText, formatDateTime }

      return (
        <Monthly key={yearMonth} {...modalProps} {...props}/>
      )
    });
  }



  return {
    getConfigurationList, renderGroupedData,
    // selectedProductTab, setSelectedProductTab
  }
}

export default useHistory;
